import React from 'react';
import Input from '../Input';

function SubscribeName({ size, state, errors, onChange }) {
  return (
    <React.Fragment>
      <Input type="text" autoComplete="given-name" className={`subscribe-${size}-input-first-name`} error={errors.firstName} name="firstName" label="First Name" placeholder="Trader" value={state.firstName} onChange={onChange} />
      <Input type="text" autoComplete="family-name" className={`subscribe-${size}-input-last-name`} error={errors.lastName} name="lastName" label="Last Name" placeholder="Joe's" value={state.lastName} onChange={onChange} />
    </React.Fragment>
  );
}

export default SubscribeName;
